/**
 * Promotion Cart Manager
 * Manages cart level displays, savings totals, and ticking countdown timers.
 */
class LcPromotionCart {
  static countdownInterval = null;

  /**
   * Initialize and update countdown timers for scheduled flash sale promotions.
   */
  static initCountdowns() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    const updateTimers = () => {
      const timers = document.querySelectorAll('[data-promo-countdown]');
      if (timers.length === 0) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
        return;
      }

      const now = new Date().getTime();

      timers.forEach(timer => {
        const endDateStr = timer.getAttribute('data-promo-countdown');
        if (!endDateStr) return;

        const endDate = new Date(endDateStr).getTime();
        const diff = endDate - now;

        const displayEl = timer.querySelector('[data-countdown-timer]');
        if (!displayEl) return;

        if (diff <= 0) {
          displayEl.textContent = 'Offer expired';
          timer.style.opacity = '0.5';
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        displayEl.textContent = `${hours}h ${minutes}m ${seconds}s`;
      });
    };

    updateTimers();
    this.countdownInterval = setInterval(updateTimers, 1000);
  }

  /**
   * Refreshes the cart summary details and toggles promotion display sections.
   * @param {object} cart - Shopify Cart object
   * @param {Array<object>} activePromos - Sorted active promotions
   */
  static updateCartSummary(cart, activePromos) {
    if (!cart) return;

    // 1. Update savings line in summary card if present
    const totalSavingsEl = document.querySelector('[data-lc-cart-savings]');
    if (totalSavingsEl) {
      const savings = cart.total_discount || 0;
      totalSavingsEl.textContent = LcPromotionUtils.formatMoney(savings);
      const savingsRow = totalSavingsEl.closest('.lc-cart-savings-row');
      if (savingsRow) {
        savingsRow.style.display = savings > 0 ? 'flex' : 'none';
      }
    }

    // 2. Scan and toggle cart drawer / cart page promotion rows
    const isCartPage = window.location.pathname.includes('/cart');
    
    activePromos.forEach(promo => {
      const widgets = document.querySelectorAll(`.lc-promo-cart-widget[data-promo-widget="${promo.id}"]`);
      
      widgets.forEach(widget => {
        const showCart = widget.getAttribute('data-promo-show-cart') === 'true';
        const showDrawer = widget.getAttribute('data-promo-show-drawer') === 'true';
        
        // Only show promotions in cart if there is at least one qualifying item in the cart
        let hasQualifyingItems = false;
        if (!promo.targetProducts?.length && !promo.targetCollection) {
          // Site-wide promotion
          hasQualifyingItems = cart.items.length > 0;
        } else {
          hasQualifyingItems = cart.items.some(item => {
            return window.LcPromotionUtils?.isItemMatching(
              item,
              promo.targetProducts,
              promo.targetCollection,
              promo.excludedProducts
            );
          });
        }

        // Determine whether to display this widget on current view
        let shouldDisplay = false;
        if (hasQualifyingItems) {
          if (isCartPage && showCart) {
            shouldDisplay = true;
          } else if (!isCartPage && showDrawer) {
            shouldDisplay = true;
          }
        }

        widget.style.display = shouldDisplay ? 'block' : 'none';
      });
    });

    // Toggle horizontal scroll class if multiple promotion cards are visible
    const containers = document.querySelectorAll('.lc-promotions-cart-widget-container');
    containers.forEach(container => {
      const visibleCount = [...container.querySelectorAll('.lc-promo-cart-widget')].filter(w => w.style.display === 'block').length;
      container.classList.toggle('has-multiple-promos', visibleCount > 1);
    });

    // 3. Kickstart countdown ticking if new widgets with countdowns are displayed
    this.initCountdowns();
  }
}

window.LcPromotionCart = LcPromotionCart;
